import { SIZES } from 'src/styles/theme'
import styled from 'styled-components'

export const StyledTabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .tab-container {
    display: flex;
    justify-content: space-around;
    margin: 36px auto;
  }
  .mobile-hide {
    display: block;
  }
  .mobile-show {
    display: none;
  }

  .tab-item {
    color: #0880AE;
    border-radius: 0px;
    font-size: 22px;
    font-weight: 600;
    padding: 4px 16px;
    cursor: pointer;
    margin: 0 8px;
  }
  .date {
    color: #fff;
  }
  
  .date.selected {
    color: #44ABE2;
    filter: brightness(1.3);
    border-radius: 4px;
    border: 1px solid red;
  }
  

  ${SIZES.mobile} {
    .tab-container {
      margin: 12px 0;
      flex-wrap: wrap;
    }
    .tab-item {
      padding: 4px 8px;
      font-size: 14px;
    }
    .date {
      color: #fff;
    }
    .date.selected {
      color: #44ABE2;
    }
    .mobile-hide {
      display: none;
    }
    .mobile-show {
      display: block;
    }
    
  }
`